import { render, staticRenderFns } from "./InvestmentsList.vue?vue&type=template&id=b1268552&"
import script from "./InvestmentsList.vue?vue&type=script&lang=ts&"
export * from "./InvestmentsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports